module.exports = __webpack_public_path__ + "img/partner_4.cc80cdb.png";